import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap';
import { not } from 'ramda'

import {Wrapper} from 'system/wrapper';
import {Message} from 'components/message';
import Input from 'form/input';
import {ButtonWrap, ButtonDefault} from 'components/buttons';

import {forgotPassword} from 'redux/actions/auth';

const mapDispatchToProps = dispatch => ({
  forgotPassword: email => dispatch(forgotPassword(email))
})

const mapStateToProps = state => ({
  error: state.auth.get('emailSendFail'),
  success: state.auth.get('emailSendSuccess')
})

class ForgotPassword extends Component {
  state = {
    email: '',
    error: false,
    success: false
  }

  renderForm = () => not(this.state.success) &&
    <React.Fragment>
      <h2>Відновлення паролю</h2>
      <Input
        type='email'
        block
        value={this.state.email}
        onChange={this.handleChangeEmail}
        placeholder="Введіть Вашу електронну пошту"
        hasError={Boolean(this.state.error)}
        errMsg={this.generateError(this.state.error)}
        onFocus={this.handleFocusEmail}
      />
      <ButtonWrap>
        <ButtonDefault
          value="Відправити"
          onClick={this.changePassword}
        />
      </ButtonWrap>
    </React.Fragment>

  renderMessage = () => this.state.success &&
    <React.Fragment>
      <Message>
        На вказану електронну адресу буде відправлено повідомлення.<br />
        Перейдіть за посиланням у листі, щоб відновити пароль.
      </Message>
    </React.Fragment>

  changePassword = () =>
    this.props.forgotPassword(this.state.email)

  handleChangeEmail = event => {
    event.persist()
    this.setState(() => ({ email: event.target.value }))
  }

  generateError = (error) => { //TODO: make file with all errors and map on file
    if(!error) return
    let msg = ''
    if(error.email && error.email[0] === "Enter a valid email address."){
      msg = 'Ви ввели невірний email'
    } else if (error.non_field_errors && error.non_field_errors[0] === 'Account for this email not found.') {
      msg = 'Обліковий запис з такою електронною поштою не знайдений'
    } else {
      msg = 'При збереженні даних виникла проблема. Перевірте, будь ласка, всі поля'
    }
    return msg
  }

  handleFocusEmail = () => this.setState(() => ({ error: '' }))

  componentWillReceiveProps (nextProps) {
    this.setState(() => ({ error: nextProps.error, success: nextProps.success }))
  }

  render () {
    return (
      <Wrapper>
        <Grid>
          <Row>
            <Col xs={12} sm={8} smOffset={2} lg={6} lgOffset={3}>
              {this.renderForm()}
              {this.renderMessage()}
            </Col>
          </Row>
        </Grid>
      </Wrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/auth/forgotPassword.js